const EMAIL_PATTERN = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;
const PHONE_PATTERN = /\+?\d[\d()\-\s]{7,}\d/;
const CARD_PATTERN = /\b(?:\d[ -]*?){13,19}\b/;
const IPV4_PATTERN = /\b(?:\d{1,3}\.){3}\d{1,3}\b/;

export function hasEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value);
}

export function hasPhone(value: string): boolean {
  return PHONE_PATTERN.test(value);
}

export function hasCardNumber(value: string): boolean {
  return CARD_PATTERN.test(value);
}

export function hasIpAddress(value: string): boolean {
  return IPV4_PATTERN.test(value);
}

export function containsPii(value: string): boolean {
  return hasEmail(value) || hasPhone(value) || hasCardNumber(value) || hasIpAddress(value);
}
